/* eslint-disable react/no-array-index-key */
import React, { useState } from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Button from '@material-ui/core/Button';
import styled from 'styled-components';
import RenderTextField from '../../../utils/renderFields/RenderTextField';
import RenderSelectField from '../../../utils/renderFields/RenderSelectField';
import returnReasonCode from '../../../utils/bindings/returnReasonCode';
import returnVoucherTypeCode from '../../../utils/bindings/returnVoucherTypeCode';
import returnVoucherItemCondition from '../../../utils/bindings/returnVoucherItemCondition';

const SubSectionTitle = styled.h3`
  font-size: 1.3em;
`;

const ButtonContainer = styled.div`
  margin-top: 50px;
  text-align: center;
`;

const RenderItem = ({ fields, currentReturnVoucher }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const nextItem = () => {
    if (currentReturnVoucher.items.length - 1 > currentIndex) {
      setCurrentIndex(currentIndex + 1);
    }
  };

  const previousItem = () => {
    if (currentIndex > 0) {
      setCurrentIndex(currentIndex - 1);
    }
  };

  const { isUpdatable, items } = currentReturnVoucher;
  for (let i = 0; i < items.length; i += 1) {
    const selectedReturnVoucherItemCondition = returnVoucherItemCondition.filter(
      element => element.name === items[i].condition
    )[0];
    if (selectedReturnVoucherItemCondition) {
      items[i].condition = selectedReturnVoucherItemCondition.publicName;
    }
  }

  return (
    <div>
      {fields.map((item, index) => (
        <div key={index}>
          {currentIndex === index ? (
            <div>
              <Grid container justify="center" spacing={2}>
                <Grid item md={6}>
                  <Field
                    name={`${item}.returnNatureCode`}
                    type="text"
                    style={{ width: '100%' }}
                    component={RenderSelectField}
                    disabled={!isUpdatable}
                    datas={returnVoucherTypeCode}
                    label="Type"
                  />
                </Grid>
                <Grid item md={6}>
                  <Field
                    name={`${item}.returnReasonCode`}
                    type="text"
                    style={{ width: '100%' }}
                    component={RenderSelectField}
                    disabled={!isUpdatable}
                    datas={returnReasonCode}
                    label="Raison du retour"
                  />
                </Grid>
                <Grid item md={12}>
                  <Field
                    name={`${item}.condition`}
                    type="text"
                    fullWidth
                    disabled
                    component={RenderTextField}
                    label="Condition du produit"
                  />
                </Grid>
              </Grid>
              <Grid container justify="center" spacing={2}>
                <Grid item md={12}>
                  <Field
                    name={`${item}.customReturnReason`}
                    type="text"
                    fullWidth
                    disabled
                    component={RenderTextField}
                    label="Commentaire"
                  />
                </Grid>
              </Grid>

              <Grid container justify="center" spacing={2}>
                <Grid item md={6}>
                  <SubSectionTitle>Produit retourné</SubSectionTitle>
                  <Grid container justify="center" spacing={2}>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.returnedItem.description`}
                        type="text"
                        fullWidth
                        component={RenderTextField}
                        disabled
                        label="Description"
                      />
                    </Grid>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.returnedItem.color`}
                        type="text"
                        fullWidth
                        component={RenderTextField}
                        disabled
                        label="Couleur"
                      />
                    </Grid>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.returnedItem.size`}
                        type="text"
                        fullWidth
                        component={RenderTextField}
                        disabled
                        label="Taille"
                      />
                    </Grid>
                  </Grid>
                  <Grid container justify="center" spacing={2}>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.returnedItem.ean13`}
                        type="text"
                        fullWidth
                        component={RenderTextField}
                        disabled
                        label="Code à barres"
                      />
                    </Grid>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.returnedItem.externalReference`}
                        type="text"
                        fullWidth
                        component={RenderTextField}
                        disabled
                        label="Référence"
                      />
                    </Grid>
                  </Grid>
                </Grid>
                <Grid item md={6}>
                  <SubSectionTitle>Produit demandé</SubSectionTitle>
                  <Grid container justify="center" spacing={2}>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.desiredItem.description`}
                        type="text"
                        fullWidth
                        disabled={!isUpdatable}
                        component={RenderTextField}
                        label="Description"
                      />
                    </Grid>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.desiredItem.color`}
                        type="text"
                        fullWidth
                        disabled={!isUpdatable}
                        component={RenderTextField}
                        label="Couleur"
                      />
                    </Grid>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.desiredItem.size`}
                        type="text"
                        fullWidth
                        disabled={!isUpdatable}
                        component={RenderTextField}
                        label="Taille"
                      />
                    </Grid>
                  </Grid>
                  <Grid container justify="center" spacing={2}>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.desiredItem.ean13`}
                        type="text"
                        fullWidth
                        disabled={!isUpdatable}
                        component={RenderTextField}
                        label="Code à barres"
                      />
                    </Grid>
                    <Grid item md={12}>
                      <Field
                        name={`${item}.desiredItem.externalReference`}
                        type="text"
                        fullWidth
                        disabled={!isUpdatable}
                        component={RenderTextField}
                        label="Référence"
                      />
                    </Grid>
                  </Grid>
                </Grid>
              </Grid>
              {items.length > 1 ? (
                <ButtonContainer>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={previousItem}
                    style={{ marginRight: 20 }}
                  >
                    Précedent
                  </Button>
                  <span>{`${currentIndex + 1} / ${fields.length}`}</span>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={nextItem}
                    style={{ marginLeft: 20 }}
                  >
                    Suivant
                  </Button>
                </ButtonContainer>
              ) : (
                ''
              )}
            </div>
          ) : (
            ''
          )}
        </div>
      ))}
    </div>
  );
};

RenderItem.propTypes = {
  fields: PropTypes.object,
  currentReturnVoucher: PropTypes.object
};

export default RenderItem;
